import { CookieSet, RoleTitleGroup } from "../../../types/campaignTypes";

export type RoleTitleCookieState = Record<string, CookieSet[]>;

export const getRoleKey = (roleTypeId: string, roleId: string) => `${roleTypeId}:${roleId}`;

export const getSelectedAdLibIds = (cookieSets: RoleTitleCookieState): number[] => {
  const ids = new Set<number>();

  Object.entries(cookieSets).forEach(([key, values]) => {
    if (key.includes("_ALL")) return;
    values.forEach((cookie) => ids.add(cookie.adLibId));
  });

  return [...ids];
};

export const getCookieStateFromAdLibIds = (
  roleTitleList: RoleTitleGroup[],
  adLibIds: number[],
): RoleTitleCookieState => {
  const idSet = new Set(adLibIds.map((id) => Number(id)));

  return roleTitleList.reduce<RoleTitleCookieState>((acc, group) => {
    group.roleSet.forEach((roleSet) => {
      const selectedCookies = roleSet.cookieSets.filter((cookie) => idSet.has(Number(cookie.adLibId)));
      if (selectedCookies.length > 0) {
        acc[getRoleKey(group.roleTypeId, roleSet.roleId)] = selectedCookies;
      }
    });
    return acc;
  }, {});
};

export const getRoleTitleLabelsFromAdLibIds = (roleTitleList: RoleTitleGroup[], adLibIds: number[]): string[] => {
  const labelsById = roleTitleList.reduce<Record<number, string>>((acc, group) => {
    group.roleSet.forEach((roleSet) => {
      roleSet.cookieSets.forEach((cookie) => {
        acc[Number(cookie.adLibId)] = `${group.roleType} - ${roleSet.role}` || cookie.title;
      });
    });
    return acc;
  }, {});

  const names = adLibIds.map((id) => labelsById[Number(id)]).filter((label): label is string => Boolean(label));
  return [...new Set(names)];
};

export const getCheckboxStateFromCookieState = (
  roleTitleList: RoleTitleGroup[],
  cookieSets: RoleTitleCookieState,
): Record<string, boolean> => {
  const base = roleTitleList.reduce<Record<string, boolean>>((acc, group) => {
    group.roleSet.forEach((roleSet) => {
      acc[getRoleKey(group.roleTypeId, roleSet.roleId)] = false;
    });
    return acc;
  }, {});

  Object.entries(cookieSets).forEach(([key, values]) => {
    base[key] = values.length > 0;
  });

  return base;
};
